import { render, staticRenderFns } from "./root.vue?vue&type=template&id=7afe421e&scoped=true&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"
import style0 from "./root.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./root.vue?vue&type=style&index=1&id=7afe421e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afe421e",
  null
  
)

export default component.exports